import React from 'react';
import Card from 'partial/components/Card';
import { useTop10Agencies } from '../hooks';

function TopAgencies() {
  const [isLoading, table] = useTop10Agencies();

  return (
    <Card className="flex flex-col">
      <h3 className="text-base font-semibold leading-6 text-neutral-900">
        Top Agencies
      </h3>
      {isLoading ? (
        <div className="mt-4 flex flex-col gap-3">
          {['a', 'b', 'c', 'd', 'e'].map((k) => (
            <div
              key={k}
              className="animate-pulse bg-neutral-100 h-6 w-full rounded"
            />
          ))}
        </div>
      ) : !table?.length ? (
        <p className="mt-4 text-sm text-neutral-500">No data available.</p>
      ) : (
        <ol className="mt-4 flex flex-col gap-3">
          {table.map((item, idx) => (
            <li
              key={item.name}
              className="flex items-center justify-between gap-2"
            >
              <span className="text-sm text-neutral-700">
                {idx + 1}. {item.name || '--'}
              </span>
              <span className="text-sm font-medium text-neutral-900 tabular-nums">
                {item.messages}
              </span>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}

export default TopAgencies;
